import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'coursenote-dialog-component',
    styleUrls: ['coursenote.dialogcomponent.css'],
    templateUrl: 'coursenote.dialogcomponent.html'
})
export class CourseNoteDialogComponent implements OnInit {
    canceltext: string;
    title: string;
    message: string;
    oktext: string;
    optionalNote: string;
    showIcon: boolean;

    constructor(public dialogRef: MatDialogRef<CourseNoteDialogComponent>, @Inject(MAT_DIALOG_DATA) data: _CourseNoteDialogOptions) {
        this.canceltext = data.CancelText || 'Cancel';
        this.oktext = data.OKText || 'OK';
        this.title = data.TitleText || 'Optional Note';
        this.message = data.MessageText || '';
        this.optionalNote = data.OptionalNote || '';
        this.showIcon = (data.ShowIcon != null ? data.ShowIcon : false);
    }
    
    ngOnInit() {

    }

    OKHandler() {
        this.dialogRef.close(this.optionalNote);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }
}

// #region Custom Classes

export class _CourseNoteDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    OptionalNote?: string;
}

// #endregion


// WEBPACK FOOTER //
// ./src/services/dialogs/coursenote/coursenote.dialogcomponent.ts